







































































































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'

import { Widget } from '../base/'

import BaseIcon from '../../../base/components/BaseIcon.vue'
import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    BaseIcon,
    NoWidgetAccess,
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: true,
    }
  },
  computed: {
    ...mapGetters(['getCurrentAlarmId']),
    currentAlarm() {
      return this.$store.state.alarm.items[this.getCurrentAlarmId] || null
    },
    infoElementsSorting() {
      return this.widget?.customSettings.settings?.sortInfoElements.data.sortedInfo
    },
    showLabels() {
      return this.widget?.customSettings.settings?.showLabels.checked
    },
    showIcons() {
      return this.widget?.customSettings.settings?.showIcons.checked
    },
    showTitleIcon() {
      return this.widget?.customSettings.settings?.showOperationsNameIcon.checked
    },
    fontSize() {
      return this.widget?.customSettings.settings?.fontSizeOther.value
    },
    fontSizeTitle() {
      return this.widget?.customSettings.settings?.fontSizeOperationsName.value
    },
    getTitleStyles() {
      return { 'font-size': `${this.fontSizeTitle}px` }
    },
    getItemStyles() {
      return { 'font-size': `${this.fontSize}px`}
    },
    getPriorityDisplayText() {
      return this.currentAlarm?.priority ? 'Einsatz mit Priorität / Sonderrechten' : ' — '
    },
    getGroupsOrUnitsName() {
      const clusters = this.currentAlarm?.cluster || []
      const groups = this.currentAlarm?.group || []
      const units = this.currentAlarm?.user_cluster_relation || []

      if (clusters.length !== 0) {
        return clusters.map((key: string | number) => this.$store.state.cluster.child[key]?.name)
      }

      if (groups.length !== 0) {
        return groups.map((key: string | number) => this.$store.state.cluster.group[key]?.name)
      }

      if (units.length !== 0) {
        return units.map((key: string | number) => this.$store.state.cluster.consumer[key]?.stdformat_name)
      }

      return false
    }
  },

})
